import React, { useState } from 'react';
import axios from 'axios';

const url = new URL(window.location.href);
const finalUrl = `/api/`;

export default function ResetPassword() {
  const [showResetPassword, setShowResetPassword] = useState(true);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get('token');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      return;
    }
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const response = await axios.post(finalUrl.concat('update-password'), {
        token,
        newPassword,
      });
      setSuccessMessage(response.data.message);
      setNewPassword('');
      setConfirmPassword('');

      setTimeout(() => {
        setShowResetPassword(false);
      }, 2000);
    } catch (error) {
      let errorMsg;
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMsg = 'Invalid or expired reset token.';
            break;
          case 404:
            errorMsg = 'User not found.';
            break;
          case 500:
            errorMsg = 'Internal server error. Please try again later.';
            break;
          default:
            errorMsg = `An unknown error occurred. Status code: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMsg =
          'Unable to connect to the server. Please check your network connection.';
      } else {
        errorMsg = `Error setting up the request: ${error.message}`;
      }
      setErrorMessage(errorMsg);
    }
  };

  return (
    <>
      {showResetPassword && (
        <div
          className="fixed inset-0 bg-[#dfdfdf] bg-opacity-50 flex items-center justify-center"
          onClick={() => setShowResetPassword(false)}
        >
          <div
            className="bg-white p-8 rounded-xl shadow-xl w-[700px] h-[400px] flex flex-col items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full">
              <h3 className="text-xl font-extrabold text-[#b82322] mb-8 text-center">
                Reset Password
              </h3>
              <form onSubmit={handleResetPassword}>
                {errorMessage && (
                  <p className="text-red-600 mb-4">{errorMessage}</p>
                )}
                {successMessage && (
                  <p className="text-green-600 mb-4">{successMessage}</p>
                )}
                <div className="space-y-2 flex flex-col items-center justify-center">
                  <input
                    type="password"
                    required
                    placeholder="Enter new password(at least 6 characters)"
                    className="w-2/3 px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-red-600 focus:border-red-600 text-sm"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <input
                    type="password"
                    required
                    placeholder="Confirm new password(Consistent with password)"
                    className="w-2/3 px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-red-600 focus:border-red-600 text-sm"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <div className="flex mt-6 w-2/3 justify-between space-x-4 mx-auto">
                  <button
                    type="button"
                    onClick={() => setShowResetPassword(false)}
                    className="w-1/2 py-3 px-4 border border-gray-300 rounded-md text-[#666666] font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 whitespace-nowrap"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-1/2 py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#b82322] hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 whitespace-nowrap"
                  >
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
